var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"countStep headerStep"},[_c('strong',[_vm._v(" "+_vm._s(_vm.activeStep)+"/"+_vm._s(_vm.totalStep)+" ")]),_c('p',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }